// import WinAmountController from '../../controllers/statusbar/WinAmountController';
import MainGridController from "../../controllers/grid/MainGridController";
import { GameConfigs } from "../../lib/globals/GameConfigs";
// import { WinAmountViewGrid } from './WinAmountViewGrid';
import { COMPONENTS } from "../../lib/constants";
import WinInfoController from "../../controllers/statusbar/WinInfoController";
import { WinInfoViewGrid } from "./WinInfoViewGrid";
// import { COMPONENTS } from "../../lib/constants";

export const WinInfo = {
  name: COMPONENTS.WIN_INFO,
  child: true,
  position: {
    x: 0,
    y: 0,
  },
  controllers: [
    {
      Controller: WinInfoController,
      name: "WinInfoController",
      config: {
        item: "COPY",
        val: "COPY",
        // holder: 'status_bar_container',
        items: [
          {
            id: 0,
            item: "TEN_00000.png",
            type: "",
          },
          {
            id: 1,
            item: "J_00000.png",
            type: "",
          },
          {
            id: 2,
            item: "Q_00000.png",
            type: "",
          },
          {
            id: 3,
            item: "K_00000.png",
            type: "",
          },
          {
            id: 4,
            item: "A_00000.png",
            type: "",
          },
          {
            id: 5,
            item: "st_major_5",
            type: "major",
          },
          {
            id: 6,
            item: "st_major_4",
            type: "major",
          },
          {
            id: 7,
            item: "st_major_3",
            type: "major",
          },
          {
            id: 8,
            item: "st_major_2",
            type: "major",
          },
          {
            id: 9,
            item: "st_major_1",
            type: "major",
          },
          {
            id: 10,
            item: "scatter_00000.png",
            type: "",
          },
          {
            id: 11,
            item: "money00.png",
            type: "",
          },
        ],
        textStyle: {
          fill: "#DF215A",
          fontFamily: "Poppins SemiBold",
          fontSize: 22,
        },
        currency: GameConfigs.auth.balance.currency,
      },
    },
    {
      Controller: MainGridController,
      name: "WinInfoViewGrid",
      config: WinInfoViewGrid,
    },
  ],
  components: [
    {
      name: "COPY",
      type: "Sprite",
      position: {
        x: 0,
        y: 0,
      },
      components: [
        {
          name: "label",
          type: "Text",
          position: {
            x: 0,
            y: 0,
          },
          text: "STATUS_BAR_COPY",
        },
        {
          name: "count",
          type: "Text",
          position: {
            x: 0,
            y: -2,
          },
          text: "STATUS_BAR_COUNT",
        },
        {
          name: "itemimg",
          type: "Sprite",
        },
      ],
    },
  ],
};
